module.exports = __webpack_public_path__ + "img/br18.4db8ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br18.jpg
// module id = 9eFl
// module chunks = 0